import "../css/Navbar.css";

const Navbar = () => {
  return (
    <nav id="usgsbanner" className="navbar navbar-expand-lg navbar-dark">
      {/* Brand Logo Section */}
      <div className="navbar-brand d-flex align-items-center">
        <a
          href="https://www.usgs.gov/"
          id="usgsidentifier"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="img/usgs_logo.png"
            alt="USGS - science for a changing world"
            title="U.S. Geological Survey Home Page"
            style={{ maxHeight: "48px" }}
          />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
